import React, { useState, useRef, useEffect } from "react";
import "../Bfsi Solution/faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const answerRefs = useRef([]);

  const faqs = [
    {
      q: "What Services Does Your Real Estate Software Development Company Offer?",
      a: "We offer a range of services, including custom real estate software development, CRM solutions for real estate agents, virtual tour development, and property listing platform development.",
    },
    {
      q: "Can You Develop a Customized Property Listing Platform Tailored to Our Specific Requirements?",
      a: "Yes, we specialize in developing customized property listing platforms to meet the unique needs and branding of our clients.",
    },
    {
      q: "How Do You Ensure the Security of Sensitive Property and User Data in Your Software Solutions?",
      a: "We prioritize data security and implement robust measures such as encryption, secure authentication, and compliance with real estate industry regulations.",
    },
    {
      q: "Can Your Software Integrate With Popular Property Listing Websites and Real Estate Portals?",
      a: "Absolutely. We ensure seamless integration with external platforms, property listing websites, and real estate portals to enhance visibility and reach.",
    },
    {
      q: "Do You Provide Virtual Tour Development Services for Showcasing Properties Online?",
      a: "Yes, we specialize in virtual tour development, allowing users to explore properties remotely through 3D tours, videos, and interactive walkthroughs.",
    },
    {
      q: "How Do You Handle Mobile Responsiveness to Ensure a Seamless User Experience on Smartphones and Tablets?",
      a: "We design our software solutions to be fully responsive on various devices, providing a seamless experience on smartphones, tablets, and desktops.",
    },
    {
      q: "Can Your Software Include Financial Calculators and Mortgage Estimation Tools for Property Buyers?",
      a: "Certainly. We can integrate financial calculators, mortgage estimators, and other tools to assist users in assessing affordability and financial planning.",
    },
    {
      q: "What Technologies Do You Use for Real Estate Software Development, and How Do You Stay Updated on Industry Trends?",
      a: "We leverage cutting-edge technologies and stay updated on industry trends through continuous learning, conferences, and active participation in the real estate technology community.",
    },
    {
      q: "Do You Offer Crm Solutions for Real Estate Agents to Manage Leads, Contacts, and Communication?",
      a: "Yes, we provide CRM solutions specifically tailored for real estate agents, helping them manage leads, contacts, and streamline communication.",
    },
    {
      q: "Can Your Software Be Customized to Support Multiple Languages and Currencies for a Global Audience?",
      a: "Absolutely. We can customize our software solutions to support multiple languages and currencies, catering to a diverse international audience.",
    },
     {
      q: "How Do You Approach Data Migration for Clients Transitioning From Existing Real Estate Software Systems to Your Solutions?",
      a: "We have a structured data migration process to ensure a smooth transition, working closely with clients to migrate data securely and accurately.",
    },
    {
      q: "What Post-launch Support and Maintenance Services Do You Provide for Your Real Estate Software Solutions?",
      a: "We offer comprehensive post-launch support, including bug fixes, updates, and ongoing maintenance to ensure the continued success of our real estate software solutions.",
    },
    {
      q: "Can You Provide Examples of Successful Real Estate Software Projects You Have Developed for Clients?",
      a: "Certainly. We can share case studies and examples of successful real estate software projects during our initial consultations.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Get height for smooth animation
  const getHeight = (index) => {
  const el = answerRefs.current[index];
  if (!el) return "0px";

  const padding = 40; // top 20 + bottom 20
  return `${el.scrollHeight + padding}px`;
};


  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Faq's</h2>

      {faqs.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.q}</span>
            <span className="faq-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Smooth answer */}
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
            style={{
              maxHeight: activeIndex === index ? getHeight(index) : "0px",
            }}
          >
            <p>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
